import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Combine plusieurs `className` Tailwind en résolvant les conflits :
 *   cn("p-2 text-sm", isActive && "p-4")  // → "text-sm p-4"
 *
 * `clsx` aplatit les conditions (booleans, arrays, objets) ; `twMerge`
 * supprime les utilities Tailwind qui se contredisent (ex. `p-2 p-4`
 * → `p-4`) en gardant la dernière occurrence. C'est la fonction `cn`
 * standard de shadcn/ui — référencée par `components.json` via l'alias
 * `@/lib/utils`.
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
